define.alias("checkout/components/containers/load-checkout-data", "settings/components/containers/load-checkout-data");